module.exports = __webpack_public_path__ + "img/category_349.ba30179a.jpg";